import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FormTextarea } from "shards-react";
import { Form, Button } from "react-bootstrap";
import {primaryColor} from '../../config/colors'
import { EntypoMinus, EntypoPlus } from "react-entypo-icons";
import "./RestaurantFoodItemDetailDialog.css";
import { strings } from "../../localization";
import { formateNumber, getTotalPriceOfFoodItem } from "../../config";

function RestaurantFoodItemDetailDialog({
  showModal,
  setShowModal,
  foodItem,
  onConfirmPressed,
  categoryId
}) {
  const [note, setNote] = useState("");
  const [itemQty, setItemQty] = useState("");

  useEffect(() => {
    console.log('foodItem in detail dialog', foodItem)
    setNote(foodItem.note);
    setItemQty(foodItem.quantity);
  }, []);

  const manageItemQuantity = (isFromIncrement) => {
    let parsedQty = parseInt(itemQty) || 0;
    if (isFromIncrement) {
      parsedQty++;
    } else {
      parsedQty--;
    }
    console.log('parsedQty in dialog', parsedQty)
    setItemQty(parsedQty.toString());
  };

  const onConfirm = () => {
    let foodData = foodItem;
    foodData.quantity = itemQty;
    foodData.note = note;
    onConfirmPressed(foodData, categoryId);
    setItemQty("");
    setNote("");
  };

  // const getTotalPrice = () => {
  //   const price = foodItem.price ? parseFloat(foodItem.price) : 0
  //   const qty = itemQty ? parseFloat(itemQty) : 0
  //   console.log('price', price)
  //   console.log('qty', qty)
  //   return formateNumber(qty < 1 ? price : (price * qty))
  // }

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable={true}
      >
        <Modal.Header closeButton>
          <h5 className="p-0 m-0 truncate-multiline">{foodItem.name}</h5>
        </Modal.Header>
        <Modal.Body className="px-3 py-2">
          <div className="container-fluid p-0 m-0">
            <div className="d-flex justify-content-between align-items-start my-2">
              <p style={{ color: primaryColor, fontSize: 20 }}>
                {/* ${foodItem.price} */}
                {/* {formateNumber(foodItem.price)} */}
                {getTotalPriceOfFoodItem(foodItem.price, itemQty)}
              </p>
              {/* RIGHT: Button or Qty Box */}
              {itemQty && itemQty > "0" ? (
                <div
                  className="d-flex align-items-center border rounded-pill px-2 py-1 bg-white fw-bold"
                  style={{ flexShrink: 0 }}
                >
                  <Button
                    variant="link"
                    onClick={(e) => {
                      manageItemQuantity();
                    }}
                    className="p-0"
                    style={{
                      border: "none",
                      boxShadow: "none",
                      color: primaryColor,
                    }}
                  >
                    <EntypoMinus />
                  </Button>

                  <Form.Control
                    type="number"
                    value={itemQty}
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (!isNaN(value) && value > 0) {
                        // handleQtyInputChanges(foodItem.id, value)
                        setItemQty(value);
                      }
                    }}
                    min="1"
                    className="mx-2 text-center no-spinner fw-bold"
                    style={{
                      width: "50px",
                      border: "none",
                      backgroundColor: primaryColor,
                      color: "white",
                      borderRadius: "8px",
                      padding: "2px 6px",
                    }}
                  />

                  <Button
                    variant="link"
                    onClick={(e) => {
                      manageItemQuantity(true);
                    }}
                    className="p-0 fw-bold"
                    style={{
                      border: "none",
                      boxShadow: "none",
                      color: primaryColor,
                    }}
                  >
                    <EntypoPlus />
                  </Button>
                </div>
              ) : (
                <div
                  className="d-flex align-items-center border rounded-pill px-4 py-2"
                  style={{
                    flexShrink: 0,
                    color: "white",
                    cursor: "pointer",
                    backgroundColor: primaryColor,
                  }}
                  onClick={(e) => {
                    manageItemQuantity(true);
                  }}
                >
                  <Button
                    variant="link"
                    className="p-0 d-flex align-items-center text-decoration-none fw-bold"
                    style={{
                      color: "white",
                    }}
                  >
                    <span>{strings.add_item.toUpperCase()}</span>
                  </Button>
                </div>
              )}
            </div>
            <FormTextarea
              value={note}
              placeHolder={strings.enter_food_instruction}
              size="lg"
              rows="4"
              onChange={(e) => setNote(e.target.value)}
            />
            <div className="saveBtnConainer">
            <Button theme="primary" onClick={onConfirm} className="saveBtn">
              {strings.confirm}
            </Button>
          </div>
            </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default RestaurantFoodItemDetailDialog;
